import { DateTime } from "luxon";

function getBucketFormat(intervalMinutes) {
  return intervalMinutes % 60 === 0 ? "HH:00" : "HH:mm";
}

function floorToInterval(dt, intervalMinutes) {
  const flooredMinute = Math.floor(dt.minute / intervalMinutes) * intervalMinutes;
  return dt.set({ minute: flooredMinute, second: 0, millisecond: 0 });
}


function bucketKey(isoUtc, userTimezone, intervalMinutes) {
  const fmt = getBucketFormat(intervalMinutes);
  const dtLocal = DateTime.fromISO(isoUtc, { zone: "utc" }).setZone(userTimezone);
  return floorToInterval(dtLocal, intervalMinutes).toFormat(fmt);
}

export function toMWh(pricePerWh) {
  if (pricePerWh == null) return null;
  return Number((pricePerWh * 1e6).toFixed(2));
}


export function mergeTimeSeries({
  sources,
  userTimezone = "UTC",
  intervalMinutes = 60,
}) {
  const map = new Map();

  const ensure = (isoUtc) => {
    const k = bucketKey(isoUtc, userTimezone, intervalMinutes);
    if (!map.has(k)) map.set(k, { time: isoUtc }); // keep an ISO for sorting
    return map.get(k);
  };

  for (const src of sources) {
    for (const r of (src.rows ?? [])) {
      const out = ensure(r.time);
      src.apply(r, out);
    }
  }

  return Array.from(map.values()).sort(
    (a, b) =>
      DateTime.fromISO(a.time, { zone: "utc" }).toMillis() -
      DateTime.fromISO(b.time, { zone: "utc" }).toMillis()
  );
}